export const CMinorImageMastheadFragments = {
  field: `
    fragment minorImageMasthead on minorImageMasthead_block_Entry {
      id
      typeHandle
      idName
      heading
      subheading
      imageDesktop {
        title
        url
        hasFocalPoint
        focalPoint
      }
      imageMobile {
        title
        url
        hasFocalPoint
        focalPoint
      }
    }
  `,
}
